import { DEFAULT_SORT_OPTION } from 'modules/brands/discovery/utils/sortOrder'
import { MachineContext } from '../../list/controllers/brandDiscoveryMachine'

export enum BrandDiscoveryUrlParam {
  CATEGORY = 'c',
  FILTERS = 'f',
  DEMOGRAPHICS = 'd',
  ORDER = 'o',
  DISPLAY = 'vis',
  PAGE = 'p',
  SHIPPING_DESTINATIONS = 's',
  SEARCH_QUERY = 'q'
}

export const buildDiscoveryFilterPath = (ctx: MachineContext) => {
  const { category, demographics, filters, order, page, display, shippingDestinations, searchQuery } = ctx
  const params = new URLSearchParams()
  demographics.forEach((d) => params.append(BrandDiscoveryUrlParam.DEMOGRAPHICS, d))
  filters.forEach((f) => params.append(BrandDiscoveryUrlParam.FILTERS, f))
  shippingDestinations.forEach((dest) => params.append(BrandDiscoveryUrlParam.SHIPPING_DESTINATIONS, dest))

  const hasCategoryPath = category && category.length > 0
  const path = hasCategoryPath ? `/categories/${category}` : '/brands'

  if (searchQuery) {
    params.set(BrandDiscoveryUrlParam.SEARCH_QUERY, searchQuery)
  }

  if (order.key !== DEFAULT_SORT_OPTION.key) {
    params.set(BrandDiscoveryUrlParam.ORDER, order.paramName)
  }

  if (display !== 'list') {
    params.set(BrandDiscoveryUrlParam.DISPLAY, display)
  }

  if (page > 1) {
    params.set(BrandDiscoveryUrlParam.PAGE, page.toString())
  }

  const queryString = params.toString()
  if (queryString) {
    return `${path}?${queryString}`
  } else {
    return path
  }
}
